import { loadSession } from '@servicedesk/ui';
import type { ReactNode } from 'react';
import { basePath } from '../config';
import { AuthCallback } from './AuthCallback';
import { MagicSignIn } from './MagicSignIn';

/**
 * Auth gate for magic-link mode. Renders the callback handler on the callback
 * path, the sign-in screen when there's no valid session, and the wrapped
 * content once signed in.
 */
export function MagicGate({ children }: { children: ReactNode }) {
  if (window.location.pathname === `${basePath}auth/callback`) return <AuthCallback />;
  if (!loadSession()) return <MagicSignIn />;
  return <>{children}</>;
}
